import { post } from '@/utils/https'
import qs from 'qs'

export const register = data => post ('/loginByPass/', qs.stringify(data))


// WEBPACK FOOTER //
// ./src/api/login.js